<dialog-header
  title="Upload Image"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div mat-dialog-content style="margin-top: 40px; margin-bottom: 20px">
  <choose-reward
    [label]="'Click here to upload'"
    [icon]="'cloud_upload'"
    (clicked)="triggerFileInput()"
  ></choose-reward>

  <input
    #fileInput
    style="display: none"
    type="file"
    (change)="fileChangeEvent($event)"
    [accept]="fileAccept"
    [multiple]="false"
  />

  <div
    style="
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
    *ngIf="imageChangedEvent"
  >
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="data.maintainAspectRatio"
      [aspectRatio]="data.aspectRatio ?? 16 / 9"
      [format]="outputFormat"
      [imageQuality]="outputFormat === 'jpeg' ? 85 : 100"
      [autoCrop]="true"
      [cropperMinWidth]="0"
      [cropperMinHeight]="0"
      [onlyScaleDown]="false"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded($event)"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>

  <div
    *ngIf="fileSize > 0"
    style="margin-top: 10px; text-align: center; font-size: 14px"
  >
    <p style="margin: 5px 0">
      <strong>Cropped size:</strong> {{ formatSize(fileSize) }}
      <span
        *ngIf="fileSize > data.maxFileSize"
        style="color: #f44336; font-weight: 600"
      >
        (Too large - max {{ formatSize(data.maxFileSize) }})
      </span>
      <span
        *ngIf="fileSize <= data.maxFileSize"
        style="color: #4caf50; font-weight: 600"
      >
        ✓
      </span>
    </p>
    <p
      *ngIf="originalFileSize > 0"
      style="font-size: 12px; color: #666; margin: 5px 0"
    >
      Original: {{ formatSize(originalFileSize) }}
    </p>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    [disabled]="false"
    (tapped)="matDialogRef.close()"
    [title]="'Cancel'"
  ></app-secondary-button>

  <app-primary-button
    [disabled]="croppedImage == ''"
    (tapped)="primaryTapped()"
    [title]="'Save'"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
